import { downloadExcavationPermitPdf, isExcavationPermit as isExcavationPermitPdf } from "../RoadClosureWorkPermit/excavationPermitPdf";
import React, { useState, useEffect, useRef } from "react";
// import "./User.css";
import { IoCloseOutline } from "react-icons/io5";
import Snackbar from "@mui/material/Snackbar"; // Import Snackbar
import MuiAlert from "@mui/material/Alert";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { TbRefresh } from "react-icons/tb";
import Tooltip from "@mui/material/Tooltip";
import API_URL from "../../src/Config";
import { IoMdArrowBack } from "react-icons/io";
import useClickOutside from "../useClickOutside";
import jsPDF from "jspdf";
import ReactDOM from "react-dom";
import html2canvas from "html2canvas";
import ColdWorkPermitTemplate from "./ColdWorkPermitTemplate";
import HotWorkPermitTemplate from "../HotWorkPermit/HotWorkPermitTemplate";
import ConfinedSpaceTemplate from "../ConfiedSpaceWorkPermit/ConfinedSpaceTemplate";

function Closerequesttab({ isSidebarExpanded, designationID }) {
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectAll, setSelectAll] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(""); // New state for Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const fetchTimeout = useRef(null);
  const [isSearching, setIsSearching] = useState(false);
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState(null);
  const [severity, setSeverity] = useState("success");
  const [isLoading, setIsLoading] = useState(false);
  const containerRef = useRef(null);
  const buttonRef = useRef(null);
  const { permit_id } = useParams();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isActionPopupOpen, setIsActionPopupOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [selectedRenewalId, setSelectedRenewalId] = useState(null);
  const [actionDesignations, setActionDesignations] = useState([]);
  const [workPermitId, setWorkPermitId] = useState(null); // State for permit_id
  const [closure_id, setClosure_id] = useState(null); // State for renewal_id

  const mapStatusToYesNo = (status) => (status === 1 ? "Yes" : "No");

  const handleSaveRejectClick = async (permit_id) => {
    if (!reason.trim()) {
      setSeverity("error");
      showSnackbar("Reason is required to reject the permit.");
      return;
    }

    const payload = {
      permit_id: permit_id,
      closure_id: closure_id,
      request_type: "closure",
      reason: reason.trim(),
    };

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      if (!authKey) {
        throw new Error("Authorization key not found");
      }

      // Make the API call
      const response = await axios.post(
        `${API_URL}/api/reject_permit`,
        payload,
        {
          headers: { Authorization: authKey },
        }
      );

      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Permit rejected successfully.");
        // closePopup();
        setTimeout(() => {
          navigate(`/work-permit-inspection?tab=Closed`);
        }, 1000);
      } else {
        throw new Error(response.data.message || "Failed to reject permit.");
      }
    } catch (error) {
      console.error("Error rejecting permit:", error);
      setSeverity("error");
      showSnackbar(
        error.response?.data?.message ||
          "An error occurred while rejecting the permit."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleRejectClick = (permit_id, closure_id) => {
    setIsPopupOpen(true);
    // Save these IDs in the state or use them directly in the popup
    setWorkPermitId(permit_id); // Save permit_id in the state
    setClosure_id(closure_id); // Save renewal_id in the state
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";

    // Create a Date object from the date string
    const date = new Date(dateString);

    // Convert to UTC and format time
    const time = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC",
    });

    // Format date to DD/MM/YYYY using UTC date methods
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based in JS
    const year = date.getUTCFullYear();

    // Combine to form the date string in DD/MM/YYYY format
    const dateStr = `${day}/${month}/${year}`;

    return `${dateStr}, ${time}`;
  };

  const handleBack = () => {
    window.history.back();
  };

  const handleDeletePopup = () => {
    setIsDeletePopup(!isDeletePopup);
  };

  const handleCancel = () => {
    setIsDeletePopup(false);
  };

  useClickOutside([containerRef, buttonRef], () => setIsSortPopup(false));

  const fetchData = async (currentPage, itemsPerPage) => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/get_permit_closure`, {
        headers: {
          Authorization: authKey,
        },
        params: {
          permit_id: permit_id,
        },
      });

      setDesignations(response.data);
      // setDesignations(response.data || [{}]);
      setTotalItems(response.data.TotalItems);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching department data:", error.message);
      setLoading(false);
    }
  };

  const fetchRenewalData = async (renewalId) => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/get_permit_renewal`, {
        headers: {
          Authorization: authKey,
        },
        params: {
          renewal_id: renewalId, // Use the passed renewal ID
        },
      });

      setActionDesignations(response.data); // Update state with the fetched data
      setLoading(false);
    } catch (error) {
      console.error("Error fetching renewal data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isActionPopupOpen && selectedRenewalId) {
      fetchRenewalData(selectedRenewalId);
    }
  }, [isActionPopupOpen, selectedRenewalId]);

  const handleSearch = async (currentPage, itemsPerPage) => {
    if (!searchInput.trim()) {
      fetchData(currentPage, itemsPerPage);
      return;
    }
    try {
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/search_designations`, {
        headers: {
          Authorization: authKey,
          "Content-Type": "application/json",
        },
        params: {
          query: searchInput,
          page: currentPage,
          per_page: itemsPerPage,
        },
      });

      if (response.status === 200) {
        setDesignations(response.data.Designations);
      } else {
        console.error("Error fetching search results:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching search results:", error.message);
    } finally {
      setLoading(false);
      setIsSearching(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    clearTimeout(fetchTimeout.current);

    // Debounce API calls by 600ms
    fetchTimeout.current = setTimeout(() => {
      if (searchInput.trim() === "") {
        fetchData(page, itemsPerPage);
      } else {
        setIsSearching(true);
        handleSearch(page, itemsPerPage);
      }
    }, 600);

    return () => clearTimeout(fetchTimeout.current);
  }, [searchInput, page, itemsPerPage]);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleArchivedDesignation = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/archive_designations`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey,
        },
        body: JSON.stringify({ ids: selectedRows }),
      });

      if (response.ok) {
        showSnackbar("Data archived successfully");
        const updatedDesignations = designations.filter(
          (designation) => !selectedRows.includes(designation.id)
        );
        setDesignations(updatedDesignations);
        fetchData();
        setSelectedRows([]);
        setSelectAll(false);
        setChecked(false);
      } else {
        console.error("Failed to delete departments");
      }
    } catch (error) {
      console.error("An error occurred while deleting designations:", error);
    }
  };

  const handleCloseButtonClick = () => {
    setChecked(false);
    setSelectedRows([]);
  };

  const handleRefresh = () => {
    if (searchInput) {
      console.log("Search input is set:", searchInput);
    } else {
      fetchData(page, itemsPerPage);
    }
    setSearchInput("");
  };
  const closePopups = () => {
    setIsSortPopup(false);
    setIsDeletePopup(false);
  };

  const handleCloseRequest = async (permit_id, closure_id) => {
    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      const response = await axios.put(
        // `${API_URL}/api/close_work_permit_request`,
        `${API_URL}/api/v2/fire_safety/approve`,
        {
          permit_id: permit_id,
          closure_id: closure_id,
          request_type: "closure",
        },
        {
          headers: {
            Authorization: authKey,
          },
        }
      );
      if (response.status === 200) {
        // setSeverity("success");
        showSnackbar("Work permit Clossed successfully!");
        await fetchData(page, itemsPerPage);
      }
    } catch (error) {
      console.error("Error saving department:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewGenratePermit = async (formId, work_permit_name) => {
    if (isExcavationPermitPdf(work_permit_name)) {
      return downloadExcavationPermitPdf(formId, { isSidebarExpanded });
    }
    let TemplateComponent;

    switch (work_permit_name?.toLowerCase()) {
      case "cold work":
        TemplateComponent = ColdWorkPermitTemplate;
        break;
      case "hot work":
        TemplateComponent = HotWorkPermitTemplate;
        break;
      case "confined space":
        TemplateComponent = ConfinedSpaceTemplate;
        break;
      default:
        console.error("Unknown permit type:", work_permit_name);
        return;
    }
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/get_permit_details`, {
        headers: { Authorization: authKey },
        params: { permit_id: formId },
      });

      if (response.status === 200) {
        const permitDetails = response.data;

        // Create a temporary container to render the template
        const tempDiv = document.createElement("div");
        document.body.appendChild(tempDiv);

        // Render the template to the temporary container
        // ReactDOM.render(
        //   <ColdWorkPermitTemplate
        //     permitDetails={permitDetails}
        //     isSidebarExpanded={false} // Adjust based on your layout
        //   />,
        //   tempDiv
        // );

        ReactDOM.render(
          <TemplateComponent
            permitDetails={permitDetails}
            isSidebarExpanded={isSidebarExpanded}
          />,
          tempDiv
        );

        // // Retrieve sections for PDF rendering
        // const section1 = tempDiv.querySelector("#section1");
        // const section2 = tempDiv.querySelector("#section2");

        // if (!section1 || !section2) {
        //   console.error("Required sections for PDF generation not found.");
        //   ReactDOM.unmountComponentAtNode(tempDiv);
        //   document.body.removeChild(tempDiv);
        //   return;
        // }

        // const pdf = new jsPDF("p", "mm", "a4");
        // const options = {
        //   scale: 2,
        //   useCORS: true,
        //   backgroundColor: "yellow",
        //   windowWidth: 1550,
        // };

        // // Render Section 1
        // const canvas1 = await html2canvas(section1, options);
        // const imgData1 = canvas1.toDataURL("image/jpeg", 0.8);
        // const imgWidth1 = 190; // A4 width minus padding
        // const imgHeight1 = (canvas1.height * imgWidth1) / canvas1.width;

        // pdf.addImage(imgData1, "JPEG", 10, 10, imgWidth1, imgHeight1);

        // // Render Section 2 (on a new page)
        // pdf.addPage();
        // const canvas2 = await html2canvas(section2, options);
        // const imgData2 = canvas2.toDataURL("image/jpeg", 0.8);
        // const imgWidth2 = 190;
        // const imgHeight2 = (canvas2.height * imgWidth2) / canvas2.width;

        // pdf.addImage(imgData2, "JPEG", 10, 10, imgWidth2, imgHeight2);

        // // Generate PDF Blob and open in a new tab
        // const pdfBlob = pdf.output("blob");
        // const pdfUrl = URL.createObjectURL(pdfBlob);
        // window.open(pdfUrl, "_blank");

        // // Clean up the temporary container
        // ReactDOM.unmountComponentAtNode(tempDiv);
        // document.body.removeChild(tempDiv);

        const section1 = tempDiv.querySelector("#section1");
        const section2 = tempDiv.querySelector("#section2");

        if (!section1 || !section2) {
          console.error("PDF sections not found.");
          return;
        }

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = 210; // A4 width in mm
        const pageHeight = 297; // A4 height in mm
        const margin = 5; // small margin all around

        const options = {
          scale: 1.8, // slightly smaller scale for better fitting
          useCORS: true,
          backgroundColor: "white",
          windowWidth: 1550,
        };

        // Render Section 1
        const canvas1 = await html2canvas(section1, options);
        const imgData1 = canvas1.toDataURL("image/jpeg", 0.9);

        const imgWidth1 = pageWidth - margin * 2;
        const imgHeight1 = (canvas1.height * imgWidth1) / canvas1.width;

        // ✅ Prevent bottom cut-off by reducing height if needed
        const adjustedHeight1 =
          imgHeight1 > pageHeight - margin * 2
            ? pageHeight - margin * 2
            : imgHeight1;

        pdf.addImage(
          imgData1,
          "JPEG",
          margin,
          margin,
          imgWidth1,
          adjustedHeight1
        );

        // Render Section 2
        const canvas2 = await html2canvas(section2, options);
        const imgData2 = canvas2.toDataURL("image/jpeg", 0.9);

        const imgWidth2 = pageWidth - margin * 2;
        const imgHeight2 = (canvas2.height * imgWidth2) / canvas2.width;

        const adjustedHeight2 =
          imgHeight2 > pageHeight - margin * 2
            ? pageHeight - margin * 2
            : imgHeight2;

        pdf.addPage();
        pdf.addImage(
          imgData2,
          "JPEG",
          margin,
          margin,
          imgWidth2,
          adjustedHeight2
        );

        // Save file safely
        const fileSafePermitName = work_permit_name.replace(/\s+/g, "_");
        const fileName = `${fileSafePermitName}_Permit_${formId}.pdf`;
        pdf.save(fileName);

        ReactDOM.unmountComponentAtNode(tempDiv);
        document.body.removeChild(tempDiv);
      } else {
        console.error("Failed to fetch permit details:", response.statusText);
      }
    } catch (error) {
      console.error("Error generating PDF:", error.message);
    }
  };

  const statusColors = {
    Pending: { color: "#D97706", fontWeight: "600" }, // Orange
    "Closure Rejected": { color: "#DC2626", fontWeight: "600" }, // Red
    "Closure Approved by Issuer": { color: "#059669", fontWeight: "600" }, // Green
    default: { color: "#6B7280" }, // Grey
  };

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          {isChecked ? (
            <div className="action-header">
              <div className="action-header-content">
                <div className="action-header-content-leftside">
                  <div className="action-button">
                    <button
                      className="delete"
                      onClick={handleDeletePopup}
                    ></button>
                    {isDeletePopup && (
                      <div className="confirm-delete-popup">
                        <div className="confirm-delete-popup-content">
                          <div className="confirm-model">
                            <div className="confirm-model-content">
                              <div className="confirm-model-content-body">
                                <p>Are you sure want to approve?</p>
                              </div>
                              <div className="confirm-model-content-footer">
                                <button
                                  className="confirm-delete-button"
                                  onClick={handleArchivedDesignation}
                                >
                                  Yes
                                </button>
                                <button
                                  className="confirm-cancel-button"
                                  onClick={handleCancel}
                                >
                                  No
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="action-header-content-rightside">
                  <button
                    className="action-header-close-button"
                    onClick={handleCloseButtonClick}
                  >
                    <IoCloseOutline className="action-header-close-icon" />
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="data-list-header">
              <div className="data-list-header-content">
                <div className="data-list-heading-content-left-side">
                  <Tooltip title="Back" arrow>
                    <IoMdArrowBack
                      className="back-company"
                      onClick={handleBack}
                    />
                  </Tooltip>
                  View Close Request
                </div>
                <div className="data-list-heading-content-right-side">
                  <Tooltip title="Refresh List" arrow>
                    <button className="refresh-button" onClick={handleRefresh}>
                      <TbRefresh className="refresh-icon" />
                    </button>
                  </Tooltip>
                </div>
              </div>
            </div>
          )}
          <div className="data-list-body" onClick={closePopups}>
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                    <div>Loading...</div>
                  </div>
                ) : designations.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th className="center-alignment">SR. NO.</th>
                        <th>COMPLETED</th>
                        <th>STOPPED</th>
                        <th>AREA CLEANED</th>
                        <th>STATUS</th>
                        <th>REQUETED AT</th>
                        <th>CLOSED AT</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {designations.map((designation, index) => (
                        <tr key={designation.id} className="hoverable-row">
                          <td className="center-alignment">{index + 1}</td>
                          <td>
                            {mapStatusToYesNo(
                              designation.completion_status || "NA"
                            )}
                          </td>
                          <td>
                            {mapStatusToYesNo(
                              designation.stoppage_status || "NA"
                            )}
                          </td>
                          <td>
                            {mapStatusToYesNo(
                              designation.area_cleaned_status || "NA"
                            )}
                          </td>
                          <td
                            style={
                              statusColors[designation.status] ||
                              statusColors.default
                            }
                          >
                            {designation.status || "NA"}
                          </td>
                          <td>
                            {formatDateTime(
                              designation.receiver_date_time || "NA"
                            )}
                          </td>
                          <td>
                            {formatDateTime(designation.closed_at || "NA")}
                          </td>

                          <td>
                            <button
                              className="new-button-download"
                              onClick={() =>
                                handleViewGenratePermit(
                                  designation.permit_id,
                                  designation.work_permit_name
                                )
                              }
                              style={{ marginLeft: "0.5rem" }}
                            >
                              View
                            </button>

                            <button
                              className="new-button-download approve_btn_clr"
                              onClick={() =>
                                handleCloseRequest(
                                  designation.permit_id,
                                  designation?.id
                                )
                              }
                              disabled={
                                designation.safety_officer_approval_status === 1
                              }
                            >
                              {isLoading ? "Approving..." : "Approve"}
                            </button>
                            <button
                              className="data-form-reject-button"
                              onClick={() =>
                                handleRejectClick(
                                  designation.permit_id,
                                  designation?.id
                                )
                              }
                              disabled={
                                designation.safety_officer_approval_status === 1
                              }
                            >
                              Reject
                            </button>

                            <div className="new-permit">
                              {/* <button
                                className="new-button-download"
                                onClick={() =>
                                  handleActionButton(designation.id)
                                }
                              >
                                Take action
                              </button> */}

                              {/* <button
                                className="new-button-download"
                                onClick={() =>
                                  handleActionButton(designation.id)
                                }
                                disabled={designation.status === "Approved" } // Disable button if status is Approved
                              >
                                Take action
                              </button> */}
                            </div>

                            {isPopupOpen && (
                              <div className="permit-popup-model">
                                <div className="form-permit-popup-content">
                                  <div className="reminder-popup-model-header">
                                    <div className="reminder-popup-model-content-header">
                                      <div className="reminder-popup-model-content-header-left-part">
                                        Reject Permit
                                      </div>
                                      <div className="reminder-popup-model-content-header-right-part"></div>
                                    </div>
                                    <div className="permit-popup-new-form">
                                      <form className="permit-popup-form-detail">
                                        <div className="new-data-form">
                                          <div className="new-form-group email-filed">
                                            <label htmlFor="reason">
                                              Reason for rejection{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </label>
                                            <div className="input-group">
                                              <textarea
                                                id="reason"
                                                name="reason"
                                                placeholder="Enter reason"
                                                value={reason}
                                                onChange={handleReasonChange}
                                                rows="4"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                    <div className="footers">
                                      <div className="form-button-group">
                                        <div>
                                          <button
                                            className="form-reject-button"
                                            type="button"
                                            onClick={() =>
                                              handleSaveRejectClick(
                                                designation.permit_id,
                                                designation?.id
                                              )
                                            }
                                          >
                                            {loading ? "Rejecting.." : "Reject"}
                                          </button>

                                          <button
                                            className="person-user-cancel-button"
                                            onClick={closePopup}
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                        <div></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">No Data Found</div>
                  </div>
                )}
              </div>
              {/* <Pagination
                  showPerPage={itemsPerPage}
                  total={totalItems}
                  onPaginationChange={handlePaginationChange}
                /> */}
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity="success">
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default Closerequesttab;

// import React, { useState, useEffect, useRef } from "react";
// // import "./User.css";
// import { IoCloseOutline } from "react-icons/io5";
// import Snackbar from "@mui/material/Snackbar"; // Import Snackbar
// import MuiAlert from "@mui/material/Alert";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
// import { TbRefresh } from "react-icons/tb";
// import Tooltip from "@mui/material/Tooltip";
// import API_URL from "../../src/Config";
// import { IoMdArrowBack } from "react-icons/io";
// import useClickOutside from "../useClickOutside";
// import jsPDF from "jspdf";
// import ReactDOM from "react-dom";
// import html2canvas from "html2canvas";
// import ColdWorkPermitTemplate from "./ColdWorkPermitTemplate";

// function Closerequesttab({ isSidebarExpanded, designationID }) {
//   const [designations, setDesignations] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectAll, setSelectAll] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState(""); // New state for Snackbar
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [isDeletePopup, setIsDeletePopup] = useState(false);
//   const [isChecked, setChecked] = useState(false);
//   const [isSortPopup, setIsSortPopup] = useState(false);
//   const [selectedRowIndex, setSelectedRowIndex] = useState(null);
//   const [searchInput, setSearchInput] = useState("");
//   const navigate = useNavigate();
//   const [page, setPage] = useState(0);
//   const [itemsPerPage, setItemsPerPage] = useState(50);
//   const [totalItems, setTotalItems] = useState(0);
//   const fetchTimeout = useRef(null);
//   const [isSearching, setIsSearching] = useState(false);
//   const [sortOrder, setSortOrder] = useState("asc");
//   const [sortColumn, setSortColumn] = useState(null);
//   const [severity, setSeverity] = useState("success");
//   const [isLoading, setIsLoading] = useState(false);
//   const containerRef = useRef(null);
//   const buttonRef = useRef(null);
//   const { permit_id } = useParams();
//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [isActionPopupOpen, setIsActionPopupOpen] = useState(false);
//   const [reason, setReason] = useState("");
//   const [selectedRenewalId, setSelectedRenewalId] = useState(null);
//   const [actionDesignations, setActionDesignations] = useState([]);
//   const [workPermitId, setWorkPermitId] = useState(null); // State for permit_id
// const [renewalId, setRenewalId] = useState(null); // State for renewal_id

//   const [formData, setFormData] = useState({
//     extension_reason: "",
//     permit_id: "",
//     id: "",
//   });

//   const mapStatusToYesNo = (status) => (status === 1 ? "Yes" : "No");

//   // useEffect(() => {
//   //   const fetchPermitDetails = async () => {
//   //     try {
//   //       const authKey = localStorage.getItem("authKey");
//   //       const response = await axios.get(
//   //         `${API_URL}/api/get_permit_details?permit_id=${permit_id}`,
//   //         {
//   //           headers: {
//   //             Authorization: authKey, // Use 'Bearer' prefix if required
//   //           },
//   //         }
//   //       );

//   //       if (response.data) {
//   //         // Set all states from the single API response
//   //         setPermitDetails(response.data);
//   //         setChecklist(response.data.checklistItems || []);
//   //         setWorkDetails(response.data.workDetails || {});
//   //         setClearanceRenewal(response.data.workDetails || {});
//   //         setPrecautions(response.data.hazardsPrecautions || [{}]);
//   //       } else {
//   //         console.warn("No permit details found.");
//   //       }
//   //     } catch (err) {
//   //       console.error("Error fetching permit details:", err);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   fetchPermitDetails();
//   // }, [permit_id]);

//   // const handleSaveRejectClick = async (permit_id, renewal_id) => {
//   //   if (!reason.trim()) {
//   //     setSeverity("error");
//   //     showSnackbar("Reason is required to reject the permit.");
//   //     return;
//   //   }

//   //   const payload = {
//   //     permit_id, // Maps to `permit_id` in backend
//   //     renewal_id,
//   //     request_type: "Extension", // Set `request_type` as "Close"
//   //     reason: reason.trim(), // Trim whitespace from the reason
//   //   };

//   //   try {
//   //     setIsLoading(true);
//   //     const authKey = localStorage.getItem("authKey");
//   //     if (!authKey) {
//   //       throw new Error("Authorization key not found");
//   //     }

//   //     // Make the API call
//   //     const response = await axios.post(
//   //       `${API_URL}/api/reject_permit`,
//   //       payload,
//   //       {
//   //         headers: { Authorization: authKey },
//   //       }
//   //     );

//   //     if (response.status === 200) {
//   //       setSeverity("success");
//   //       showSnackbar("Permit rejected successfully.");
//   //       closePopup();
//   //       // setTimeout(() => {
//   //       //   navigate(`/cold-work-permit`);
//   //       // }, 1000);
//   //     } else {
//   //       throw new Error(response.data.message || "Failed to reject permit.");
//   //     }
//   //   } catch (error) {
//   //     console.error("Error rejecting permit:", error);
//   //     setSeverity("error");
//   //     showSnackbar(
//   //       error.response?.data?.message ||
//   //         "An error occurred while rejecting the permit."
//   //     );
//   //   } finally {
//   //     setIsLoading(false);
//   //   }
//   // };

//   const handleSaveRejectClick = async () => {
//     if (!reason.trim()) {
//       setSeverity("error");
//       showSnackbar("Reason is required to reject the permit.");
//       return;
//     }

//     const payload = {
//       permit_id: workPermitId,  // Get from state
//       renewal_id: renewalId,         // Get from state
//       request_type: "Closer",     // Set `request_type` as "Close"
//       reason: reason.trim(),        // Trim whitespace from the reason
//     };

//     try {
//       setIsLoading(true);
//       const authKey = localStorage.getItem("authKey");
//       if (!authKey) {
//         throw new Error("Authorization key not found");
//       }

//       // Make the API call
//       const response = await axios.post(
//         `${API_URL}/api/reject_permit`,
//         payload,
//         {
//           headers: { Authorization: authKey },
//         }
//       );

//       if (response.status === 200) {
//         setSeverity("success");
//         showSnackbar("Permit rejected successfully.");
//         // closePopup();
//         setTimeout(() => {
//           navigate(`/work-permit-inspection?tab=Closed`);
//         }, 1000);
//       } else {
//         throw new Error(response.data.message || "Failed to reject permit.");
//       }
//     } catch (error) {
//       console.error("Error rejecting permit:", error);
//       setSeverity("error");
//       showSnackbar(
//         error.response?.data?.message ||
//           "An error occurred while rejecting the permit."
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleButtonClick = (index) => {
//     setSelectedRowIndex(index === selectedRowIndex ? null : index);
//   };

//   // const handleRejectClick = () => {
//   //   setIsPopupOpen(true);
//   // };

//   const handleRejectClick = (permit_id, renewal_id) => {
//     setIsPopupOpen(true);
//     // Save these IDs in the state or use them directly in the popup
//     setWorkPermitId(permit_id); // Save permit_id in the state
//     setRenewalId(renewal_id); // Save renewal_id in the state
//   };

//   const handleReasonChange = (e) => {
//     setReason(e.target.value);
//   };

//   const closePopup = () => {
//     setIsPopupOpen(false);
//   };

//   const formatDateTime = (dateString) => {
//     if (!dateString) return "N/A";

//     // Create a Date object from the date string
//     const date = new Date(dateString);

//     // Convert to UTC and format time
//     const time = date.toLocaleTimeString("en-US", {
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//       timeZone: "UTC",
//     });

//     // Format date to DD/MM/YYYY using UTC date methods
//     const day = String(date.getUTCDate()).padStart(2, "0");
//     const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based in JS
//     const year = date.getUTCFullYear();

//     // Combine to form the date string in DD/MM/YYYY format
//     const dateStr = `${day}/${month}/${year}`;

//     return `${dateStr}, ${time}`;
//   };

//   const handleBack = () => {
//     window.history.back();
//   };

//   const handleDeletePopup = () => {
//     setIsDeletePopup(!isDeletePopup);
//   };
//   const handleSort = (column) => {
//     const order =
//       sortColumn === column && sortOrder[column] === "asc" ? "desc" : "asc";

//     setSortColumn(column);
//     setSortOrder((prevOrder) => ({
//       ...prevOrder,
//       [column]: order,
//     }));

//     setIsSortPopup(false);

//     const sortedBreakdown = [...designations].sort((a, b) => {
//       const aValue = a[column]?.toString().toLowerCase() || "";
//       const bValue = b[column]?.toString().toLowerCase() || "";

//       if (aValue < bValue) return order === "asc" ? -1 : 1;
//       if (aValue > bValue) return order === "asc" ? 1 : -1;
//       return 0;
//     });

//     setDesignations(sortedBreakdown);
//   };

//   const handleCancel = () => {
//     setIsDeletePopup(false);
//   };

//   useClickOutside([containerRef, buttonRef], () => setIsSortPopup(false));

//   const fetchData = async (currentPage, itemsPerPage) => {
//     try {
//       setLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       const response = await axios.get(`${API_URL}/api/get_permit_closure`, {
//         headers: {
//           Authorization: authKey,
//         },
//         params: {
//           permit_id: permit_id,
//         },
//       });

//       setDesignations(response.data);
//       // setDesignations(response.data || [{}]);
//       setTotalItems(response.data.TotalItems);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching department data:", error.message);
//       setLoading(false);
//     }
//   };

//   // const fetchRenewalData = async (id) => {
//   //   try {
//   //     setLoading(true);
//   //     const authKey = localStorage.getItem("authKey");

//   //     const response = await axios.get(`${API_URL}/api/get_permit_renewal`, {
//   //       headers: {
//   //         Authorization: authKey,
//   //       },
//   //       params: {
//   //         renewal_id: id,
//   //       },
//   //     });

//   //     setDesignations(response.data);
//   //     // setDesignations(response.data || [{}]);
//   //     setTotalItems(response.data.TotalItems);
//   //     setLoading(false);
//   //   } catch (error) {
//   //     console.error("Error fetching department data:", error.message);
//   //     setLoading(false);
//   //   }
//   // };

//   // useEffect(() => {
//   //   fetchRenewalData();
//   // }, []); // Empty dependency array

//   const fetchRenewalData = async (renewalId) => {
//     try {
//       setLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       const response = await axios.get(`${API_URL}/api/get_permit_renewal`, {
//         headers: {
//           Authorization: authKey,
//         },
//         params: {
//           renewal_id: renewalId, // Use the passed renewal ID
//         },
//       });

//       setActionDesignations(response.data); // Update state with the fetched data
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching renewal data:", error.message);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (isActionPopupOpen && selectedRenewalId) {
//       fetchRenewalData(selectedRenewalId);
//     }
//   }, [isActionPopupOpen, selectedRenewalId]);

//   const handleSearch = async (currentPage, itemsPerPage) => {
//     if (!searchInput.trim()) {
//       fetchData(currentPage, itemsPerPage);
//       return;
//     }
//     try {
//       const authKey = localStorage.getItem("authKey");

//       const response = await axios.get(`${API_URL}/api/search_designations`, {
//         headers: {
//           Authorization: authKey,
//           "Content-Type": "application/json",
//         },
//         params: {
//           query: searchInput,
//           page: currentPage,
//           per_page: itemsPerPage,
//         },
//       });

//       if (response.status === 200) {
//         setDesignations(response.data.Designations);
//       } else {
//         console.error("Error fetching search results:", response.statusText);
//       }
//     } catch (error) {
//       console.error("Error fetching search results:", error.message);
//     } finally {
//       setLoading(false);
//       setIsSearching(false);
//     }
//   };

//   useEffect(() => {
//     setLoading(true);
//     clearTimeout(fetchTimeout.current);

//     // Debounce API calls by 600ms
//     fetchTimeout.current = setTimeout(() => {
//       if (searchInput.trim() === "") {
//         fetchData(page, itemsPerPage);
//       } else {
//         setIsSearching(true);
//         handleSearch(page, itemsPerPage);
//       }
//     }, 600);

//     return () => clearTimeout(fetchTimeout.current);
//   }, [searchInput, page, itemsPerPage]);

//   const handlePaginationChange = (currentPage, itemsPerPage) => {
//     setPage(currentPage);
//     setItemsPerPage(itemsPerPage);
//     localStorage.setItem("currentPage", currentPage);
//     localStorage.setItem("itemsPerPage", itemsPerPage);
//   };

//   const handleSelectAll = () => {
//     const newSelectAll = !selectAll;
//     setSelectAll(newSelectAll);
//     setSelectedRows(
//       newSelectAll ? designations.map((designation) => designation.id) : []
//     );
//     setChecked(newSelectAll);
//   };

//   const handleSelectRow = (designationID) => {
//     const updatedSelectedRows = selectedRows.includes(designationID)
//       ? selectedRows.filter((id) => id !== designationID)
//       : [...selectedRows, designationID];

//     setSelectedRows(updatedSelectedRows);
//     setSelectAll(updatedSelectedRows.length === designations.length);
//     setChecked(updatedSelectedRows.length > 0);
//   };
//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbarOpen(false);
//   };

//   const showSnackbar = (message) => {
//     setSnackbarMessage(message);
//     setSnackbarOpen(true);
//   };

//   const handleArchivedDesignation = async () => {
//     try {
//       const authKey = localStorage.getItem("authKey");
//       const apiUrl = `${API_URL}/api/archive_designations`;

//       const response = await fetch(apiUrl, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: authKey,
//         },
//         body: JSON.stringify({ ids: selectedRows }),
//       });

//       if (response.ok) {
//         showSnackbar("Data archived successfully");
//         const updatedDesignations = designations.filter(
//           (designation) => !selectedRows.includes(designation.id)
//         );
//         setDesignations(updatedDesignations);
//         fetchData();
//         setSelectedRows([]);
//         setSelectAll(false);
//         setChecked(false);
//       } else {
//         console.error("Failed to delete departments");
//       }
//     } catch (error) {
//       console.error("An error occurred while deleting designations:", error);
//     }
//   };

//   const handleCloseButtonClick = () => {
//     setChecked(false);
//     setSelectedRows([]);
//   };

//   const handleSortpopup = () => {
//     setIsSortPopup(!isSortPopup);
//   };

//   const handleArchiveDesignation = () => {
//     navigate("/archived-designations");
//   };

//   const handleSearchInputChange = (event) => {
//     setSearchInput(event.target.value);
//   };

//   const handleRefresh = () => {
//     if (searchInput) {
//       console.log("Search input is set:", searchInput);
//     } else {
//       fetchData(page, itemsPerPage);
//     }
//     setSearchInput("");
//   };
//   const closePopups = () => {
//     setIsSortPopup(false);
//     setIsDeletePopup(false);
//   };

//   const handleClosepopup = () => {
//     setIsActionPopupOpen(false);
//   };

//   const handleEditExtension = (workPermitId) => {
//     navigate(`/edit-extension/${workPermitId}`);
//   };

//   const handleEditExtensionReason = (workPermitId) => {
//     navigate(`/edit-extension-reason/${workPermitId}`);
//   };

//   const handleExtensionIssuClick = async (renewal_id) => {
//     try {
//       // Retrieve the authKey from localStorage
//       const authKey = localStorage.getItem("authKey");

//       if (!authKey) {
//         console.error("Authorization key not found");
//         return;
//       }

//       // API call to approve the work permit
//       const response = await axios.put(
//         `${API_URL}/api/renew_permit_extension`,
//         { renewal_id }, // Send form_id in the request body
//         {
//           headers: {
//             Authorization: authKey, // Pass the Authorization header
//           },
//         }
//       );

//       // Check the API response status

//       if (response.status === 200) {
//         console.log(response.data.message);
//         setSeverity("success");
//         showSnackbar("Work permit approved successfully!");
//         setTimeout(() => {
//           navigate("/work-permit-inspection");
//         }, 1000);
//       }
//     } catch (error) {
//       console.error("Error saving department:", error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCloseRequest = async (permit_id) => {
//     try {
//       setIsLoading(true);
//       const authKey = localStorage.getItem("authKey");
//       const response = await axios.put(
//         `${API_URL}/api/close_work_permit_request`,
//         { permit_id: permit_id, },
//         {
//           headers: {
//             Authorization: authKey,
//           },
//         }
//       );
//       if (response.status === 200) {
//         // setSeverity("success");
//         showSnackbar("Work permit Clossed successfully!");
//         await fetchData(page, itemsPerPage,);
//       }
//     } catch (error) {
//       console.error("Error saving department:", error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleExtensionSaveClick = async (renewal_id) => {
//     try {
//       // Retrieve the authKey from localStorage
//       const authKey = localStorage.getItem("authKey");

//       if (!authKey) {
//         console.error("Authorization key not found");
//         return;
//       }

//       // API call to approve the work permit
//       const response = await axios.put(
//         `${API_URL}/api/approve_permit_extension`,
//         { renewal_id }, // Send form_id in the request body
//         {
//           headers: {
//             Authorization: authKey, // Pass the Authorization header
//           },
//         }
//       );

//       // Check the API response status

//       if (response.status === 200) {
//         console.log(response.data.message);
//         setSeverity("success");
//         showSnackbar("Work permit approved successfully!");
//         setTimeout(() => {
//           navigate("/work-permit-inspection");
//         }, 1000);
//       }
//     } catch (error) {
//       console.error("Error saving department:", error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // const handleActionButton = () => {
//   //   setIsActionPopupOpen(true);
//   // };

//   const handleActionButton = async (renewalId) => {
//     try {
//       setIsActionPopupOpen(true); // Open the popup
//       await fetchRenewalData(renewalId); // Fetch data with the provided renewal ID
//     } catch (error) {
//       console.error("Error handling action button:", error.message);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleExtensionReason = async (renewalId) => {
//     // Prepare payload
//     const payload = {
//       permit_id: permit_id,
//       renewal_id: renewalId,
//       additional_instruction: formData.additional_instruction, // Get from formData
//     };

//     try {
//       setIsLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       const response = await axios.put(
//         `${API_URL}/api/update_permit_extension`,
//         payload,
//         {
//           headers: { Authorization: authKey },
//         }
//       );

//       if (response.status === 200) {
//         setSeverity("success");
//         showSnackbar("Permit renewed successfully.");
//         setTimeout(() => {
//           navigate(`/permit-requests`);
//         }, 1000);
//       } else {
//         throw new Error(response.data.message || "Failed to renew permit.");
//       }
//     } catch (error) {
//       console.error("Error renewing permit:", error);
//       setSeverity("error");
//       const errorMessage =
//         error.response?.data?.message ||
//         "An error occurred while renewing the permit.";
//       showSnackbar(errorMessage);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // const handleViewGenratePermit = async (formId) => {
//   //   try {
//   //     const authKey = localStorage.getItem("authKey");
//   //     const response = await axios.get(`${API_URL}/api/get_permit_details`, {
//   //       headers: { Authorization: authKey },
//   //       params: { permit_id: formId },
//   //     });

//   //     if (response.status === 200) {
//   //       const permitDetails = response.data;

//   //       // Create a temporary container to render the template
//   //       const tempDiv = document.createElement("div");
//   //       document.body.appendChild(tempDiv);

//   //       // Render the template to the temporary container
//   //       ReactDOM.render(
//   //         <ColdWorkPermitTemplate
//   //           permitDetails={permitDetails}
//   //           isSidebarExpanded={false} // Adjust based on your layout
//   //         />,
//   //         tempDiv
//   //       );

//   //       // Retrieve sections for PDF rendering
//   //       const section1 = tempDiv.querySelector("#section1");
//   //       const section2 = tempDiv.querySelector("#section2");

//   //       if (!section1 || !section2) {
//   //         console.error("Required sections for PDF generation not found.");
//   //         ReactDOM.unmountComponentAtNode(tempDiv);
//   //         document.body.removeChild(tempDiv);
//   //         return;
//   //       }

//   //       const pdf = new jsPDF("p", "mm", "a4");
//   //       const options = {
//   //         scale: 2,
//   //         useCORS: true,
//   //         backgroundColor: "yellow",
//   //         windowWidth: 1550,
//   //       };

//   //       // Render Section 1
//   //       const canvas1 = await html2canvas(section1, options);
//   //       const imgData1 = canvas1.toDataURL("image/jpeg", 0.8);
//   //       const imgWidth1 = 190; // A4 width minus padding
//   //       const imgHeight1 = (canvas1.height * imgWidth1) / canvas1.width;

//   //       pdf.addImage(imgData1, "JPEG", 10, 10, imgWidth1, imgHeight1);

//   //       // Render Section 2 (on a new page)
//   //       pdf.addPage();
//   //       const canvas2 = await html2canvas(section2, options);
//   //       const imgData2 = canvas2.toDataURL("image/jpeg", 0.8);
//   //       const imgWidth2 = 190;
//   //       const imgHeight2 = (canvas2.height * imgWidth2) / canvas2.width;

//   //       pdf.addImage(imgData2, "JPEG", 10, 10, imgWidth2, imgHeight2);

//   //       // Generate PDF Blob and open in a new tab
//   //       const pdfBlob = pdf.output("blob");
//   //       const pdfUrl = URL.createObjectURL(pdfBlob);
//   //       window.open(pdfUrl, "_blank");

//   //       // Clean up the temporary container
//   //       ReactDOM.unmountComponentAtNode(tempDiv);
//   //       document.body.removeChild(tempDiv);
//   //     } else {
//   //       console.error("Failed to fetch permit details:", response.statusText);
//   //     }
//   //   } catch (error) {
//   //     console.error("Error generating PDF:", error.message);
//   //   }
//   // };

//   const handleViewGenratePermit = async (formId) => {
//     try {
//       const authKey = localStorage.getItem("authKey");
//       const response = await axios.get(`${API_URL}/api/get_permit_details`, {
//         headers: { Authorization: authKey },
//         params: { permit_id: formId },
//       });

//       if (response.status === 200) {
//         const permitDetails = response.data;

//         // Create a temporary container to render the template
//         const tempDiv = document.createElement("div");
//         document.body.appendChild(tempDiv);

//         // Render the template to the temporary container
//         ReactDOM.render(
//           <ColdWorkPermitTemplate
//             permitDetails={permitDetails}
//             isSidebarExpanded={false} // Adjust based on your layout
//           />,
//           tempDiv
//         );

//         // Retrieve sections for PDF rendering
//         const section1 = tempDiv.querySelector("#section1");
//         const section2 = tempDiv.querySelector("#section2");

//         if (!section1 || !section2) {
//           console.error("Required sections for PDF generation not found.");
//           ReactDOM.unmountComponentAtNode(tempDiv);
//           document.body.removeChild(tempDiv);
//           return;
//         }

//         const pdf = new jsPDF("p", "mm", "a4");
//         const options = {
//           scale: 2,
//           useCORS: true,
//           backgroundColor: "yellow",
//           windowWidth: 1550,
//         };

//         // Render Section 1
//         const canvas1 = await html2canvas(section1, options);
//         const imgData1 = canvas1.toDataURL("image/jpeg", 0.8);
//         const imgWidth1 = 190; // A4 width minus padding
//         const imgHeight1 = (canvas1.height * imgWidth1) / canvas1.width;

//         pdf.addImage(imgData1, "JPEG", 10, 10, imgWidth1, imgHeight1);

//         // Render Section 2 (on a new page)
//         pdf.addPage();
//         const canvas2 = await html2canvas(section2, options);
//         const imgData2 = canvas2.toDataURL("image/jpeg", 0.8);
//         const imgWidth2 = 190;
//         const imgHeight2 = (canvas2.height * imgWidth2) / canvas2.width;

//         pdf.addImage(imgData2, "JPEG", 10, 10, imgWidth2, imgHeight2);

//         // Generate PDF Blob and open in a new tab
//         const pdfBlob = pdf.output("blob");
//         const pdfUrl = URL.createObjectURL(pdfBlob);
//         window.open(pdfUrl, "_blank");

//         // Clean up the temporary container
//         ReactDOM.unmountComponentAtNode(tempDiv);
//         document.body.removeChild(tempDiv);
//       } else {
//         console.error("Failed to fetch permit details:", response.statusText);
//       }
//     } catch (error) {
//       console.error("Error generating PDF:", error.message);
//     }
//   };

//   return (
//     <>
//       <div
//         className={`data-list-content-container page-content ${
//           isSidebarExpanded ? "expanded" : "collapsed"
//         }`}
//       >
//         <div className="data-list-content" ref={containerRef}>
//           {isChecked ? (
//             <div className="action-header">
//               <div className="action-header-content">
//                 <div className="action-header-content-leftside">
//                   <div className="action-button">
//                     <button className="delete" onClick={handleDeletePopup}>
//                     </button>
//                     {isDeletePopup && (
//                       <div className="confirm-delete-popup">
//                         <div className="confirm-delete-popup-content">
//                           <div className="confirm-model">
//                             <div className="confirm-model-content">
//                               <div className="confirm-model-content-body">
//                                 <p>Are you sure want to approve?</p>
//                               </div>
//                               <div className="confirm-model-content-footer">
//                                 <button
//                                   className="confirm-delete-button"
//                                   onClick={handleArchivedDesignation}
//                                 >
//                                   Yes
//                                 </button>
//                                 <button
//                                   className="confirm-cancel-button"
//                                   onClick={handleCancel}
//                                 >
//                                   No
//                                 </button>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//                 <div className="action-header-content-rightside">
//                   <button
//                     className="action-header-close-button"
//                     onClick={handleCloseButtonClick}
//                   >
//                     <IoCloseOutline className="action-header-close-icon" />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ) : (
//             <div className="data-list-header">
//               <div className="data-list-header-content">
//                 <div className="data-list-heading-content-left-side">
//                   <Tooltip title="Back" arrow>
//                     <IoMdArrowBack
//                       className="back-company"
//                       onClick={handleBack}
//                     />
//                   </Tooltip>
//                   View Closing Request
//                 </div>
//                 <div className="data-list-heading-content-right-side">
//                   {/* <div className="search-bar-container">
//                     <input
//                       type="text"
//                       placeholder="Search..."
//                       value={searchInput}
//                       onChange={handleSearchInputChange}
//                       className="search-bar"
//                     />
//                     <IoSearchOutline className="search-bar-icon" />
//                   </div>

//                   <Link to="/designation-form" className="data-list-new">
//                     <Tooltip title="New designation" arrow>
//                       <button className="new-button">
//                         <HiOutlinePlus className="new-plus-icon" /> New
//                       </button>
//                     </Tooltip>
//                   </Link> */}

// {/* <button
//   className="new-button-download"
//   onClick={() => {
//     if (designations.length > 0) {
//       handleViewGenratePermit(designations[0].permit_id);
//     }
//   }}
// >
//   View Permit Request
// </button> */}

//                   <Tooltip title="Refresh List" arrow>
//                     <button className="refresh-button" onClick={handleRefresh}>
//                       <TbRefresh className="refresh-icon" />
//                     </button>
//                   </Tooltip>

//                   {/* <button
//                     className="sort-button"
//                     onClick={handleSortpopup}
//                     ref={buttonRef}
//                   >
//                     <PiDotsThreeOutlineVerticalFill className="sort-icon" />
//                   </button>
//                   {isSortPopup && (
//                     <div className="sort-popup-container" ref={containerRef}>
//                       <div className="sort-popup-content">
//                         <div className="sort-by">
//                           SORT BY{" "}
//                           {sortOrder[sortColumn] === "asc"
//                             ? "(Ascending)"
//                             : "(Descending)"}
//                         </div>
//                         <div className="sort-by-button">
//                           <button
//                             onClick={() => handleSort("designation_name")}
//                           >
//                             Designations{" "}
//                             {sortOrder.designation_name === "asc" ? (
//                               <MdExpandMore />
//                             ) : (
//                               <MdExpandLess />
//                             )}
//                           </button>{" "}
//                           <br />
//                           <br />
//                         </div>
//                         <button
//                           className="delete-item"
//                           onClick={handleArchiveDesignation}
//                         >
//                           Archived Designations
//                         </button>
//                       </div>
//                     </div>
//                   )} */}
//                 </div>
//               </div>
//             </div>
//           )}
//           <div className="data-list-body" onClick={closePopups}>
//             <div className="data-list-scroll-body">
//               <div className="data-list-table">
//                 {loading ? (
//                   <div className="loader-container">
//                     <div className="loader"></div>
//                     <div>Loading...</div>
//                   </div>
//                 ) : designations.length > 0 ? (
//                   <table className="table multilevel-data">
//                     <thead>
//                       <tr>
//                         {/* <th className="center-alignment">
//                           <input
//                             type="checkbox"
//                             checked={selectAll}
//                             onChange={handleSelectAll}
//                           />
//                         </th> */}
//                         <th className="center-alignment">SR. NO.</th>
//                         <th>COMPLETED</th>
//                         <th>STOPPED</th>
//                         <th>AREA CLEANED</th>
//                         <th>CLOSING REQ TIME</th>
//                         <th>ACTION</th>
//                       </tr>
//                     </thead>
//                     <tbody className="data-list-scroll-bodys">
//                       {designations.map((designation, index) => (
//                         <tr key={designation.id} className="hoverable-row">
//                           {/* <td className="center-alignment">
//                             <input
//                               type="checkbox"
//                               checked={selectedRows.includes(designation.id)}
//                               onChange={() => handleSelectRow(designation.id)}
//                             />
//                           </td> */}

//                           <td className="center-alignment">{index + 1}</td>
//                           <td>{mapStatusToYesNo (designation.completion_status || "NA")}</td>
//                           <td>{mapStatusToYesNo (designation.stoppage_status || "NA")}</td>
//                           <td>{mapStatusToYesNo (designation.area_cleaned_status || "NA")}</td>
//                           <td>
//                             {formatDateTime(designation.receiver_date_time || "NA")}
//                           </td>

//                           {/* <td>
//                             <div className="new-permit">
//                               {designation.is_renewed === 0 && (
//                                 <button
//                                   className="new-button-download"
//                                   onClick={() =>
//                                     handleEditExtension(designation.id)
//                                   }
//                                 >
//                                   Add Precautions
//                                 </button>
//                               )}

//                               {designation.is_renewed === 1 && (
//                                 <button
//                                   className="new-button-download"
//                                   onClick={() =>
//                                     handleEditExtension(designation.id)
//                                   }
//                                 >
//                                   Edit Precautions
//                                 </button>
//                               )}

//                               <button
//                                 className="new-button-download"
//                                 onClick={() =>
//                                   handleExtensionSaveClick(designation.id)
//                                 }
//                               >
//                                 Approve Extenstion request
//                               </button>

//                               <button
//                                 className="new-button-download"
//                                 onClick={() =>
//                                   handleExtensionIssuClick(designation.id)
//                                 }
//                               >
//                                 Issue Extenstion request
//                               </button>

//                               <button
//                                 className="new-button-download"
//                                 onClick={() =>
//                                   handleDownloadPdf(designation.permit_id)
//                                 }
//                               >
//                                 Download
//                               </button>

//                               <button
//                                 className="data-form-reject-button"
//                                 onClick={() =>
//                                   handleRejectClick(designation.permit_id)
//                                 }
//                               >
//                                 Reject
//                               </button>

//                               {isPopupOpen && (
//                                 <div className="reminder-popup-model">
//                                   <div className="reminder-popup-content">
//                                     <div className="reminder-popup-model-header">
//                                       <div className="reminder-popup-model-content-header">
//                                         <div className="reminder-popup-model-content-header-left-part">
//                                           Reject Request Permit
//                                         </div>
//                                         <div className="reminder-popup-model-content-header-right-part"></div>
//                                       </div>
//                                       <div className="popup-new-form">
//                                         <form className="popup-form-detail">
//                                           <div className="new-data-form">
//                                             <div className="form-group email-filed">
//                                               <label htmlFor="reason">
//                                                 Reason{" "}
//                                                 <span className="text-danger">
//                                                   *
//                                                 </span>
//                                               </label>
//                                               <div className="input-group">
//                                                 <textarea
//                                                   id="reason"
//                                                   name="reason"
//                                                   placeholder="Enter reason for rejected"
//                                                   value={reason}
//                                                   onChange={handleReasonChange}
//                                                 />
//                                               </div>
//                                             </div>
//                                           </div>
//                                         </form>
//                                       </div>
//                                       <div className="footers">
//                                         <div className="button-group-email">
//                                           <div>
//                                             <button
//                                               className="person-user-save-button"
//                                               type="button"
//                                               onClick={() =>
//                                                 handleSaveRejectClick(
//                                                   designation.permit_id
//                                                 )
//                                               }
//                                             >
//                                               Ok
//                                             </button>

//                                             <button
//                                               className="person-user-cancel-button"
//                                               onClick={closePopup}
//                                             >
//                                               Cancel
//                                             </button>
//                                           </div>
//                                           <div></div>
//                                         </div>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </div>
//                               )}

//                             </div>
//                           </td> */}

//                           <td>
//                           <button
//                                           className="new-button-download"
//                                           onClick={() =>
//                                             handleViewGenratePermit(
//                                               designation.permit_id
//                                             )
//                                           }
//                                         >
//                                           View Permit Request
//                                         </button>
//                               <button
//                                 className="new-button-download"
//                                 onClick={() =>
//                                   handleCloseRequest(designation.permit_id)
//                                 }
//                                 disabled={
//                                   designation.safety_officer_approval_status === 1
//                                 }
//                               >
//                                {isLoading
//                                 ? "Approving..."
//                                 : "Approve"}
//                               </button>
//                               <button
//                                 className="data-form-reject-button"
//                                 onClick={() =>
//                                   handleRejectClick(designation.permit_id)
//                                 }
//                                 disabled={
//                                   designation.safety_officer_approval_status === 1
//                                 }
//                               >
//                                 Reject
//                               </button>

//                               <button
//                                           className="new-button-download"
//                                           onClick={() =>
//                                             handleViewGenratePermit(
//                                               designation.permit_id
//                                             )
//                                           }
//                                         >
//                                           View
//                                         </button>

//                             <div className="new-permit">
//                               {/* <button
//                                 className="new-button-download"
//                                 onClick={() =>
//                                   handleActionButton(designation.id)
//                                 }
//                               >
//                                 Take action
//                               </button> */}

//                               {/* <button
//                                 className="new-button-download"
//                                 onClick={() =>
//                                   handleActionButton(designation.id)
//                                 }
//                                 disabled={designation.status === "Approved" } // Disable button if status is Approved
//                               >
//                                 Take action
//                               </button> */}

//                             </div>

//                             {isPopupOpen && (
//                               <div className="permit-popup-model">
//                                 <div className="permit-popup-content">
//                                   <div className="reminder-popup-model-header">
//                                     <div className="reminder-popup-model-content-header">
//                                       <div className="reminder-popup-model-content-header-left-part">
//                                         Reject Request Permit
//                                       </div>
//                                       <div className="reminder-popup-model-content-header-right-part"></div>
//                                     </div>
//                                     <div className="popup-new-form">
//                                       <form className="permit-popup-form-detail">
//                                         <div className="new-data-form">
//                                           <div className="form-group email-filed">
//                                             <label htmlFor="reason">
//                                               Reason{" "}
//                                               <span className="text-danger">
//                                                 *
//                                               </span>
//                                             </label>
//                                             <div className="input-group">
//                                               <textarea
//                                                 id="reason"
//                                                 name="reason"
//                                                 placeholder="Enter reason for rejected"
//                                                 value={reason}
//                                                 onChange={handleReasonChange}
//                                               />
//                                             </div>
//                                           </div>
//                                         </div>
//                                       </form>
//                                     </div>
//                                     <div className="footers">
//                                       <div className="button-group-email">
//                                         <div>
//                                           <button
//                                             className="person-user-save-button"
//                                             type="button"
//                                             onClick={() =>
//                                               handleSaveRejectClick(
//                                                 designation.permit_id
//                                               )
//                                             }
//                                           >
//                                             Ok
//                                           </button>

//                                           <button
//                                             className="person-user-cancel-button"
//                                             onClick={closePopup}
//                                           >
//                                             Cancel
//                                           </button>
//                                         </div>
//                                         <div></div>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             )}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 ) : (
//                   <div className="no-users-container">
//                     <div className="no-users-message">No Data Found</div>
//                   </div>
//                 )}
//               </div>
//               {/* <Pagination
//                   showPerPage={itemsPerPage}
//                   total={totalItems}
//                   onPaginationChange={handlePaginationChange}
//                 /> */}
//             </div>
//           </div>
//         </div>
//       </div>
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         style={{ marginTop: "35px", marginLeft: "20px" }}
//       >
//         <MuiAlert onClose={handleSnackbarClose} severity="success">
//           {snackbarMessage}
//         </MuiAlert>
//       </Snackbar>
//     </>
//   );
// }

// export default Closerequesttab;
